import type { AxiosInstance } from 'axios';

export interface AzureTokenResponse {
  accessToken: string;
  hostname?: string;
  region: string;
  endpointUrl?: string;
}

export interface ProcessSpeechToFormRequest {
  transcript: string;
  brandIdentifier?: string;
}

export interface ProcessSpeechToFormResponse {
  physicianName?: string;
  interactionType?: string;
  topics?: string[];
  product?: string;
  sentiment?: string;
  insight?: string;
}

export interface AwsSpeechSignedUrlResponse {
  signedUrl: string;
}

export class SpeechClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  fetchAzureSpeechAuthorizationToken = async (): Promise<AzureTokenResponse> => {
    const response = await this.authenticatedClient.get('/speech/azure-token');
    if (response.status !== 200) {
      throw new Error('Failed to fetch Azure Speech subscription key');
    }
    return response.data;
  };

  processSpeechToForm = async (data: ProcessSpeechToFormRequest): Promise<ProcessSpeechToFormResponse> => {
    const response = await this.authenticatedClient.post<ProcessSpeechToFormResponse>('/speech/process-to-form', data);
    return response.data;
  };

  fetchAwsSpeechSignedUrl = async (): Promise<AwsSpeechSignedUrlResponse> => {
    const response = await this.authenticatedClient.get(`/speech/aws-signed-url`);
    if (response.status !== 200) {
      throw new Error('Failed to fetch AWS Speech signed URL');
    }
    return response.data;
  };
}